import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useCurrentUser } from 'api/hooks/useCurrentUser';
import { useEnableUserQuickSwitcherForLocation } from 'api/hooks/useLocationSetting';
import useEnableUserQuickSwitcher from './useEnableUserQuickSwitcher';
import { setLastUsedUserEmail } from './useLastUsedUserEmail';
import { resolveOverrideOffSetting } from 'utils/helpers/locationSetting.helpers';

// persists the signed-in user's email so the quick switcher and the next login can pre-select it
export const useRememberLastLoginUser = (): void => {
  const { isAuthenticated } = useAuth0();
  const { data: user } = useCurrentUser();
  const { forLocation: quickSwitcherForLocation } = useEnableUserQuickSwitcherForLocation();
  const [quickSwitcherOnThisBrowser] = useEnableUserQuickSwitcher();
  const quickSwitcherEnabled = resolveOverrideOffSetting(quickSwitcherForLocation, quickSwitcherOnThisBrowser);

  useEffect(() => {
    if (!isAuthenticated || !quickSwitcherEnabled || !user?.email) {
      return;
    }

    setLastUsedUserEmail(user.email);
  }, [isAuthenticated, quickSwitcherEnabled, user?.email]);
};
